import * as React from 'react'
import { ISchool } from '../../interfaces/school.interface'
import { Button, CircularProgress, Typography } from '@mui/material'
import useBlogs from './useBlogs'
import { GetUserDetails } from '../../services/config'
import { useIsSmallScreen } from '@/components/utilsHooks/useIsSmallScreen'

export default function BlogPostSubscriptionInput(props: {
  textStyle?: React.CSSProperties
  textLabel?: string
  school: ISchool
  subscribeArticleId?: string
}) {
  const [email, setEmail] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const blogHook = useBlogs()
  const smallScreenHook = useIsSmallScreen()

  React.useEffect(() => {
    const userDetails = GetUserDetails()
    if (userDetails?.email) {
      setEmail(userDetails?.email)
    }
  }, [])

  function handleEmailChange(e: any) {
    setEmail(e.target.value)
  }

  async function addSubscriber() {
    setLoading(true)
    await blogHook.addSchoolBlogSubscriber({
      schoolId: props.school?._id,
      subscribeArticleId: props.subscribeArticleId,
      email: email,
    })
    setLoading(false)
  }

  return (
    <div style={{ maxWidth: '500px', padding: '20px', margin: 'auto' }}>
      <Typography style={{ ...props.textStyle }} align={'center'}>
        {props.textLabel ||
          `Thanks for reading ${props.school?.name} Newsletter! Subscribe for free
          to receive new posts`}
      </Typography>
      <div>
        <form onSubmit={addSubscriber}>
          <div
            style={{
              width: 'auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                margin: '5px',
                background: '#f1f3f4',
                padding: '10px 20px',
                borderRadius: '10px',
              }}
            >
              <input
                type="text"
                onKeyDown={e => {
                  e?.stopPropagation()
                }}
                style={{
                  background: 'transparent',
                  border: 0,
                  outline: 0,
                  width: smallScreenHook.isSmallScreen ? '200px' : '500px',
                }}
                placeholder="Email"
                value={email}
                onChange={handleEmailChange}
              />
              <div>
                <Button
                  disableElevation={true}
                  variant={'contained'}
                  color="primary"
                  size="small"
                  disabled={loading}
                  onClick={addSubscriber}
                >
                  Subscribe {loading && <CircularProgress size={15} />}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
